<div class="feedback-bar" [class.mod-active]="errors$ | async">
  <cp-icon class="feedback-bar-icon" icon="error-outline" [size]="26"></cp-icon>
  <div class="feedback-bar-text">{{(errors$ | async)?.message | translate}}</div>
  <div class="feedback-bar-dismiss" (click)="hide()">✓</div>
</div>
